/**
 * Тип содержимого снимка для отправки на сервер. Браузер не перекодирует фото: оно уходит как выбрано, а служба `media` сама читает
 * формат. Но сервер требует `Content-Type: image/*`, а Chrome на Windows отдаёт HEIC с пустым `file.type`. Тогда тип берётся
 * из расширения имени; байты не меняются.
 */
const TYPE_BY_EXTENSION: Readonly<Record<string, string>> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  heic: 'image/heic',
  heif: 'image/heif',
}

/** Тип снимка: свой, если браузер его назвал; иначе по расширению имени; неизвестное расширение — пустая строка. */
export function imageContentType(file: { type: string; name?: string }): string {
  if (file.type !== '') return file.type
  const name = file.name ?? ''
  const dot = name.lastIndexOf('.')
  return dot < 0 ? '' : (TYPE_BY_EXTENSION[name.slice(dot + 1).toLowerCase()] ?? '')
}

/** Тот же файл, если тип уже назван (или определить его нельзя); иначе новый `File` с теми же байтами и выставленным типом. */
export function withImageType(file: File): File {
  if (file.type !== '') return file
  const type = imageContentType(file)
  return type === '' ? file : new File([file], file.name, { type, lastModified: file.lastModified })
}
